// @ts-check
(function(){
  /**
   * Open the cart drawer error modal.
   * @param {string} message
   */
  function showCartErrorModal(message) {
    document.dispatchEvent(new CustomEvent('cart:error', {
      detail: { message },
    }));
  }

  /**
   * Read Shopify's cart error payload.
   * @param {Response} response
   * @param {string} fallback
   * @returns {Promise<string>}
   */
  async function readCartErrorMessage(response, fallback) {
    try {
      const errorData = await response.json();
      if (errorData && typeof errorData.description === 'string' && errorData.description) {
        return errorData.description;
      }
      if (errorData && typeof errorData.message === 'string' && errorData.message) {
        return errorData.message;
      }
    } catch (error) {
      console.error('[Product Showcase] Could not parse cart error:', error);
    }

    return fallback;
  }

  function getSelectedSizeCartSelection() {
    const urlVariantId = new URLSearchParams(window.location.search).get('variant') || '';
    if (urlVariantId) {
      const byUrlVariant = /** @type {HTMLElement|null} */(
        document.querySelector('.product-variants--size .variant-product__button[data-variant-id="' + CSS.escape(urlVariantId) + '"]')
      );
      if (byUrlVariant) {
        const variantId = byUrlVariant.getAttribute('data-cart-variant-id') || byUrlVariant.getAttribute('data-variant-id') || '';
        const sellingPlanId = byUrlVariant.getAttribute('data-cart-selling-plan-id') || '';
        const isStarterKitOverride = !!(
          byUrlVariant.getAttribute('data-cart-variant-id')
          && byUrlVariant.getAttribute('data-variant-id')
          && byUrlVariant.getAttribute('data-cart-variant-id') !== byUrlVariant.getAttribute('data-variant-id')
        );
        return { variantId, sellingPlanId, isStarterKitOverride };
      }
    }
    const selBtn = /** @type {HTMLElement|null} */(
      document.querySelector('.product-variants--size .variant-product.variant-product-selected .variant-product__button')
      || document.querySelector('.product-variants--size .variant-product.variant-product--active .variant-product__button')
      || document.querySelector('.product-variants--size .variant-product__button')
    );
    if (!selBtn) return { variantId: '', sellingPlanId: '', isStarterKitOverride: false };
    const variantId = selBtn.getAttribute('data-cart-variant-id') || selBtn.getAttribute('data-variant-id') || '';
    const sellingPlanId = selBtn.getAttribute('data-cart-selling-plan-id') || '';
    const isStarterKitOverride = !!(
      selBtn.getAttribute('data-cart-variant-id')
      && selBtn.getAttribute('data-variant-id')
      && selBtn.getAttribute('data-cart-variant-id') !== selBtn.getAttribute('data-variant-id')
    );
    return { variantId, sellingPlanId, isStarterKitOverride };
  }

  function getSelectedSizeCartVariantId() {
    return getSelectedSizeCartSelection().variantId;
  }

  function getSelectedSizeButton() {
    return /** @type {HTMLElement|null} */(
      document.querySelector('.product-variants--size .variant-product.variant-product-selected .variant-product__button')
      || document.querySelector('.product-variants--size .variant-product.variant-product--active .variant-product__button')
      || document.querySelector('.product-variants--size .variant-product__button')
    );
  }

  function getCurrentPdpVariantId() {
    const urlVariantId = new URLSearchParams(window.location.search).get('variant') || '';
    if (urlVariantId) return urlVariantId;

    const selectedSizeBtn = getSelectedSizeButton();
    if (selectedSizeBtn) {
      const selectedSizeVariantId = selectedSizeBtn.getAttribute('data-variant-id') || '';
      if (selectedSizeVariantId) return selectedSizeVariantId;
    }

    const sectionRoot = /** @type {HTMLElement|null} */(document.querySelector('.product-showcase'));
    const defaultVariantId = sectionRoot ? (sectionRoot.getAttribute('data-default-variant-id') || '') : '';
    if (defaultVariantId) return defaultVariantId;

    return '';
  }

  function isActionsV2Context() {
    const root = /** @type {HTMLElement|null} */(document.querySelector('#subscribe-options-static'));
    return !!(root && root.getAttribute('data-actions-version') === 'v2');
  }

  function initProductVideo() {
    const wrappers = /** @type {NodeListOf<HTMLElement>} */(document.querySelectorAll('.product-showcase__video'));
    wrappers.forEach((wrap) => {
      const video = /** @type {HTMLVideoElement|null} */(wrap.querySelector('.product-showcase__video-el'));
      const playBtn = /** @type {HTMLElement|null} */(wrap.querySelector('.product-showcase__video-play'));
      if (!video || !playBtn) return;

      const hasAutoplay = video.hasAttribute('autoplay');
      
      video.controls = true;
      
      if (hasAutoplay) {
        playBtn.style.display = 'none';
        video.play().catch(() => {
          playBtn.style.display = '';
        });
      } else {
        playBtn.style.display = '';
        video.pause();
      }

      function startPlayback() {
        try {
          video.play().then(() => {
            playBtn.style.display = 'none';
          }).catch(() => {
            video.controls = true;
          });
        } catch (e) {
          video.controls = true;
        }
      }

      // Play on button click
      playBtn.addEventListener('click', (e) => {
        e.preventDefault();
        startPlayback();
      }, { once: true });

      // Also allow click on video poster to start
      video.addEventListener('click', () => {
        if (video.paused) startPlayback();
      });
    });
  }
  document.addEventListener('click', function(e){
    // Bundle variant selection is handled dynamically in mgo-variants.js (lines 974-1050)
    // No need to handle it here to avoid page reload

    // Dropdown toggle by clicking the actions header inside a subscribe container
    const headerClick = /** @type {HTMLElement|null} */(e.target instanceof Element ? e.target.closest('.product-showcase__subscribe--container .product-showcase__actions--header') : null);
    if (headerClick) {
      const container = /** @type {HTMLElement|null} */(headerClick.closest('.product-showcase__subscribe--container'));
      if (container) {
        e.preventDefault();
        // In single layout, do NOT toggle; just ensure it's open
        if (isSingleLayout()) {
          ensureOpen(container);
        } else {
          toggleDropdownByContainer(container);
        }

        // Keep purchase option state in sync when users click the accordion header.
        // Without this, One-Time can look selected visually but ATC may still use a stale subscription option.
        const linkedOption = /** @type {HTMLElement|null} */(container.querySelector('.product-showcase__subscribe--option'));
        if (linkedOption) {
          const clickEvt = new Event('click', { bubbles: true, cancelable: true });
          linkedOption.dispatchEvent(clickEvt);
        }
        return; // do not fall-through
      }
    }

    const addToCartButton = /** @type {HTMLElement|null} */(e.target instanceof Element ? e.target.closest('.product-showcase__add-to-cart') : null);
    if (addToCartButton) {
      handleAddToCartClick(e, addToCartButton);
      return;
    }

    // Accept clicks on subscribe options anywhere (including special container)
    const opt = /** @type {HTMLElement|null} */(e.target instanceof Element ? e.target.closest('.product-showcase__subscribe--option') : null);
    if (!opt) return;
    e.preventDefault();
    // Scope selection to the nearest subscribe container if possible
    const container = /** @type {HTMLElement|null} */(opt.closest('.product-showcase__subscribe--container') || opt.closest('#subscribe-options-static, #purchase-options'));
    const atcButtons = /** @type {NodeListOf<HTMLAnchorElement>} */(document.querySelectorAll('.product-showcase__add-to-cart'));
    if (!container || !atcButtons.length) return;

    // Toggle visual selected state (selected + active for AJAX handler)
    const optionsRoot = /** @type {HTMLElement|null} */(document.querySelector('#subscribe-options-static'));
    const isOtpAccordion = !!(optionsRoot && optionsRoot.classList.contains('ps-otp-accordion'));
    if (isOtpAccordion && optionsRoot) {
      optionsRoot.querySelectorAll('.product-showcase__subscribe--option').forEach(el => el.classList.remove('is-selected'));
    } else {
      container.querySelectorAll('.product-showcase__subscribe--option').forEach(el => el.classList.remove('is-selected'));
    }
    opt.classList.add('is-selected');
    // Also mark this option as active so mgo-variants.js getActivePurchaseOption() picks it up
    document.querySelectorAll('.product-showcase__subscribe--option').forEach(el => el.classList.remove('is-active'));
    opt.classList.add('is-active');

    const type = opt.getAttribute('data-type') || 'onetime';
    const planId = opt.getAttribute('data-selling-plan-id') || '';
    const variantIdOverride = opt.getAttribute('data-variant-id') || '';
    const canOptionOverrideVariant = type === 'subscription-special';

    // Broadcast explicit user intent so mgo-variants.js can persist choice across size switches.
    document.dispatchEvent(new CustomEvent('pdp:purchase-choice-changed', {
      detail: {
        type,
        sellingPlanId: planId,
        variantId: variantIdOverride,
        origin: 'user',
      },
    }));

    const href = atcButtons[0].getAttribute('href') || '/cart/add';
    const url = new URL(href, window.location.origin);
    // Always clear selling_plan first
    url.searchParams.delete('selling_plan');
    // Set selling_plan whenever the option carries a planId (covers subscription and subscription-special)
    const sizeSelection = getSelectedSizeCartSelection();
    const isV2Context = isActionsV2Context();
    const isOnetime = type === 'onetime';
    // If this option points to a different product/variant (starter kit), override the id param
    if (canOptionOverrideVariant && variantIdOverride) {
      url.searchParams.set('id', variantIdOverride);
    } else if (isOnetime && isV2Context) {
      // One-time purchase: always use the actual PDP variant (data-variant-id), never the SK (data-cart-variant-id)
      const pdpVariantId = getCurrentPdpVariantId();
      if (pdpVariantId) url.searchParams.set('id', pdpVariantId);
    } else if (variantIdOverride && !isV2Context) {
      // Legacy blocks (Actions / Actions OTP): keep original behavior using option variant override.
      url.searchParams.set('id', variantIdOverride);
    } else {
      // Reset id to the main product's currently selected variant to avoid lingering starter-kit id
      let mainVariantId = sizeSelection.variantId || getSelectedSizeCartVariantId();
      if (!mainVariantId) {
        const params = new URLSearchParams(location.search);
        mainVariantId = params.get('variant') || '';
      }
      if (mainVariantId) url.searchParams.set('id', mainVariantId);
    }
    if (canOptionOverrideVariant) {
      if (planId) url.searchParams.set('selling_plan', planId);
    } else if (isV2Context && !isOnetime && sizeSelection.isStarterKitOverride) {
      // SK selling plan only for subscription flows, never for one-time
      if (sizeSelection.sellingPlanId) url.searchParams.set('selling_plan', sizeSelection.sellingPlanId);
    } else if (!isOnetime && planId) {
      url.searchParams.set('selling_plan', planId);
    }
    const qs = url.searchParams.toString();
    const newHref = qs ? (url.pathname + '?' + qs) : url.pathname;
    // Update all buttons EXCEPT the one-time only button (which should always add current product without subscription)
    atcButtons.forEach(btn => {
      if (!btn.hasAttribute('data-onetime-only')) {
        btn.setAttribute('href', newHref);
      }
    });

    // Update header (title, badge, price, compare) inside the SAME subscribe container
    const containerEl = /** @type {HTMLElement|null} */(opt.closest('.product-showcase__subscribe--container'));
    const headerScope = /** @type {HTMLElement|null} */(containerEl?.querySelector('.product-showcase__actions--header') || null);
    const headerTitle = /** @type {HTMLElement|null} */(headerScope?.querySelector('.product-showcase__actions--header--title') || null);
    const headerPriceWrap = /** @type {HTMLElement|null} */(containerEl?.querySelector('.product-showcase__price') || null);
    const headerPriceEl = /** @type {HTMLElement|null} */(headerPriceWrap?.querySelector('.product-showcase__current-price') || null);
    const headerCompareEl = /** @type {HTMLElement|null} */(headerPriceWrap?.querySelector('.product-showcase__compare-price') || null);
    if (headerTitle && headerPriceEl) {
      // Save original header title text on first interaction (from Liquid/customizer)
      if (!headerTitle.dataset.originalTitle) {
        // Extract only text nodes, excluding the badge span
        const textNodes = Array.from(headerTitle.childNodes)
          .filter(n => n.nodeType === Node.TEXT_NODE)
          .map(n => (n.textContent || '').trim())
          .filter(t => t !== '')
          .join(' ');
        headerTitle.dataset.originalTitle = textNodes || '';
      }
      
      // Get title from clicked option
      const titleEl = /** @type {HTMLElement|null} */(opt.querySelector('.product-showcase__subscribe--options--title'));
      // Clone text without inner badge
      let titleText = '';
      if (titleEl) {
        // Extract only the text nodes from title element (exclude child spans)
        titleText = (titleEl.childNodes && titleEl.childNodes.length)
          ? Array.from(titleEl.childNodes).filter(n => n.nodeType === Node.TEXT_NODE).map(n => n.textContent || '').join('').trim()
          : (titleEl.textContent || '').trim();
      }
      
      // If no title text found in option, use the original header title (from customizer)
      if (!titleText) {
        titleText = headerTitle.dataset.originalTitle || '';
      }
      
      // If still no title and it's one-time, use default
      if (!titleText && type !== 'subscription') {
        titleText = 'One-Time Purchase';
      }
      
      headerTitle.innerHTML = `${titleText} <span class="product-showcase__actions--header--title--save"></span>`;
      const headerBadge = /** @type {HTMLElement|null} */(headerTitle.querySelector('.product-showcase__actions--header--title--save'));

      // Find sibling options to compute compare price and save % when needed
      const optionsScope = /** @type {HTMLElement|null} */(document.querySelector('#subscribe-options-static'));
      const oneOpt = /** @type {HTMLElement|null} */(optionsScope?.querySelector('.product-showcase__subscribe--option[data-type="onetime"]') || null);

      // Selected price (text and numeric cents if available)
      const selectedPriceText = opt.getAttribute('data-price-text') || (opt.querySelector('.product-showcase__subscribe--options--price')?.textContent || '').trim();
      const selectedPriceCents = Number(opt.getAttribute('data-price') || '') || NaN;
      if (selectedPriceText) headerPriceEl.textContent = selectedPriceText;

      // Handle compare price and badge
      if (headerBadge) {
        if (type && type.startsWith('subscription')) {
          // For subscription, compare to one-time
          const basePriceText = oneOpt?.getAttribute('data-price-text') || (oneOpt?.querySelector('.product-showcase__subscribe--options--price')?.textContent || '').trim();
          const basePriceCents = Number(oneOpt?.getAttribute('data-price') || '') || NaN;
          // Set compare price visible with one-time price
          // BUT preserve original compare price if no one-time option exists (e.g., starter-kit template)
          if (headerCompareEl) {
            // Save original Liquid compare price on first interaction (never overwrite once set)
            if (!headerCompareEl.dataset.originalCompare) {
              headerCompareEl.dataset.originalCompare = (headerCompareEl.textContent || '').trim();
            }

            // For the OTP accordion block, prefer Liquid compare price and fallback to one-time price.
            // For legacy single-subscribe, use one-time option price as compare.
            const isOtpAccordion = !!headerCompareEl.closest('.ps-otp-accordion');
            if (isOtpAccordion) {
              const liquidCompare = (headerCompareEl.dataset.originalCompare || '').trim();
              if (liquidCompare) {
                headerCompareEl.textContent = liquidCompare;
              } else if (basePriceText) {
                headerCompareEl.textContent = basePriceText;
              } else {
                headerCompareEl.textContent = '';
              }
            } else if (basePriceText) {
              // Legacy: show one-time price as strikethrough compare
              headerCompareEl.textContent = basePriceText;
            } else {
              headerCompareEl.textContent = headerCompareEl.dataset.originalCompare || '';
            }
          }
          // Set badge from the clicked option's badge text when available
          const optionBadge = /** @type {HTMLElement|null} */(opt.querySelector('.product-showcase__subscribe--options--title--save'));
          const badgeText = (optionBadge?.textContent || '').trim();
          headerBadge.textContent = badgeText || '';
          headerBadge.style.display = badgeText ? '' : 'none';
          // Hide compare if equals current
          if (headerCompareEl) {
            const same = (headerCompareEl.textContent || '').trim() === (headerPriceEl.textContent || '').trim();
            const hasCompare = !same && !!(headerCompareEl.textContent || '').trim();
            headerCompareEl.classList.toggle('is-hidden', !hasCompare);
            headerCompareEl.setAttribute('aria-hidden', hasCompare ? 'false' : 'true');
            if (headerPriceWrap) headerPriceWrap.classList.toggle('has-compare', hasCompare);
          }
        } else {
          // For one-time: no badge; hide/clear compare price
          headerBadge.textContent = '';
          headerBadge.style.display = 'none';
          // Use original compare_at_price if present (saved on first click)
          if (headerCompareEl) {
            // Save original compare price text once
            if (!headerCompareEl.dataset.originalCompare) {
              headerCompareEl.dataset.originalCompare = (headerCompareEl.textContent || '').trim();
            }
            headerCompareEl.textContent = headerCompareEl.dataset.originalCompare || '';
            const same = (headerCompareEl.textContent || '').trim() === (headerPriceEl.textContent || '').trim();
            const hasCompare = !same && !!(headerCompareEl.textContent || '').trim();
            headerCompareEl.classList.toggle('is-hidden', !hasCompare);
            headerCompareEl.setAttribute('aria-hidden', hasCompare ? 'false' : 'true');
            if (headerPriceWrap) headerPriceWrap.classList.toggle('has-compare', hasCompare);
          }
        }
      }

      // Broadcast selection so Sticky bar can sync (include compare information)
      const selectedTitle = (opt.querySelector('.product-showcase__subscribe--options--title')?.textContent || '').trim();
      /** @type {string} */
      let compareTextForSticky = '';
      if (type && type.startsWith('subscription')) {
        // one-time price as compare
        compareTextForSticky = (headerCompareEl?.textContent || '').trim();
      } else {
        // restore original compare (if any)
        compareTextForSticky = (headerCompareEl?.dataset.originalCompare || '').trim();
      }
      const hasCompareForSticky = !!compareTextForSticky && compareTextForSticky !== (headerPriceEl?.textContent || '').trim();
      document.dispatchEvent(new CustomEvent('pdp:option-selected', {
        detail: {
          source: 'main',
          type,
          planId,
          variantId: variantIdOverride || '',
          priceText: selectedPriceText,
          priceCents: selectedPriceCents,
          title: selectedTitle,
          compareText: compareTextForSticky,
          hasCompare: hasCompareForSticky
        }
      }));

      // Toggle dropdown functionality
      toggleDropdown(opt);

      // Ensure sticky bar is visible after selection
      ensureStickyVisible();
      
      // Toggle subscription guarantees visibility
      toggleSubscriptionGuarantees(type);
    }
  }, true);

  /**
   * Toggle visibility of subscription guarantees based on selection type
   * @param {string} type - The type of selection ('subscription', 'subscription-special', 'onetime')
   */
  function toggleSubscriptionGuarantees(type) {
    const guarantees1 = /** @type {HTMLElement|null} */(document.getElementById('subscription-guarantees-1'));
    const guarantees2 = /** @type {HTMLElement|null} */(document.getElementById('subscription-guarantees-2'));
    
    // Show subscription-only items only for subscription types
    const shouldShow = type && type.startsWith('subscription');
    
    // Toggle subscription-only items in both guarantee blocks
    [guarantees1, guarantees2].forEach(guaranteeBlock => {
      if (guaranteeBlock) {
        const subscriptionOnlyItems = guaranteeBlock.querySelectorAll('.subscription-only');
        subscriptionOnlyItems.forEach(item => {
          item.style.display = shouldShow ? '' : 'none';
        });
      }
    });
  }

  // Helper to apply current selection to header/ATC
  function applyCurrentSelection() {
    const container = /** @type {HTMLElement|null} */(document.querySelector('#subscribe-options-static'));
    if (!container) return;
    // Prefer an already selected option
    let target = /** @type {HTMLElement|null} */(container.querySelector('.product-showcase__subscribe--option.is-selected'));
    // Otherwise pick the first purchase option in the whole list
    if (!target) {
      target = /** @type {HTMLElement|null} */(container.querySelector('.product-showcase__subscribe--option'));
    }
    if (!target) return;

    // Lock compare price from Liquid before the click handler overwrites it
    const compareElBefore = /** @type {HTMLElement|null} */(document.querySelector('#ps-slot-price .product-showcase__compare-price'));
    const lockedCompareText = compareElBefore ? (compareElBefore.textContent || '').trim() : '';
    const lockedCompareVisible = compareElBefore ? !compareElBefore.classList.contains('is-hidden') : false;

    const evt = new Event('click', { bubbles: true, cancelable: true });
    target.dispatchEvent(evt);

    // Restore Liquid-accurate compare price after click handler runs
    const compareElAfter = /** @type {HTMLElement|null} */(document.querySelector('#ps-slot-price .product-showcase__compare-price'));
    if (compareElAfter && lockedCompareText) {
      compareElAfter.textContent = lockedCompareText;
      compareElAfter.classList.toggle('is-hidden', !lockedCompareVisible);
      compareElAfter.setAttribute('aria-hidden', lockedCompareVisible ? 'false' : 'true');
      compareElAfter.dataset.originalCompare = lockedCompareText;
    }

    // If single layout, ensure container remains open after applying selection
    ensureSingleOpen();
  }

  // Enforce simplified purchase options: keep only One-Time and Starter Kit when special exists
  function enforceTwoOptionsSimplified() {
    const root = /** @type {HTMLElement|null} */(document.querySelector('#subscribe-options-static'));
    if (!root) return;
    const specialOpt = /** @type {HTMLElement|null} */(root.querySelector('.product-showcase__subscribe--option[data-type="subscription-special"]'));
    const hasSpecial = !!specialOpt;
    const onetimeOpt = /** @type {HTMLElement|null} */(root.querySelector('.product-showcase__subscribe--option[data-type="onetime"]'));
    const selectedOpt = /** @type {HTMLElement|null} */(root.querySelector('.product-showcase__subscribe--option.is-selected'));

    if (hasSpecial) {
      // Hide the standard subscription container if present
      const stdSubOpt = /** @type {HTMLElement|null} */(root.querySelector('.product-showcase__subscribe--container .product-showcase__subscribe--option[data-type="subscription"]'));
      const stdContainer = /** @type {HTMLElement|null} */(stdSubOpt ? stdSubOpt.closest('.product-showcase__subscribe--container') : null);
      if (stdContainer) {
        stdContainer.style.display = 'none';
        stdContainer.setAttribute('aria-hidden', 'true');
      }

      // If the current selection is onetime, keep it; otherwise default to special
      const keepOnetimeSelected = !!(onetimeOpt && selectedOpt && selectedOpt === onetimeOpt);
      const selectedIsHiddenStd = !!(selectedOpt && stdContainer && stdContainer.contains(selectedOpt));
      if (!keepOnetimeSelected && (!selectedOpt || selectedIsHiddenStd)) {
        root.querySelectorAll('.product-showcase__subscribe--option').forEach(el => el.classList.remove('is-selected', 'is-active'));
        if (specialOpt) {
          specialOpt.classList.add('is-selected');
          specialOpt.classList.add('is-active');
        }
      }
      // Keep single layout open if that's the case
      ensureSingleOpen();
    } else {
      // No special available: ensure standard subscription is visible if present
      const stdSubOpt = /** @type {HTMLElement|null} */(root.querySelector('.product-showcase__subscribe--container .product-showcase__subscribe--option[data-type="subscription"]'));
      const stdContainer = /** @type {HTMLElement|null} */(stdSubOpt ? stdSubOpt.closest('.product-showcase__subscribe--container') : null);
      if (stdContainer) {
        stdContainer.style.display = '';
        stdContainer.removeAttribute('aria-hidden');
      }
      // Also ensure open if only one container exists
      ensureSingleOpen();
    }
  }

  // Ensure the single subscribe container is open (used on init and after product/variant swaps)
  function ensureSingleOpen() {
    if (!isSingleLayout()) return;
    const root = /** @type {HTMLElement|null} */(document.querySelector('#subscribe-options-static'));
    if (!root) return;
    // Find the VISIBLE container (not hidden by display:none)
    const allContainers = /** @type {NodeListOf<HTMLElement>} */(root.querySelectorAll('.product-showcase__subscribe--container'));
    /** @type {HTMLElement|null} */
    let visibleContainer = null;
    allContainers.forEach(cont => {
      const isHidden = cont.style.display === 'none' || cont.getAttribute('aria-hidden') === 'true';
      if (!isHidden && !visibleContainer) {
        visibleContainer = cont;
      }
    });
    if (visibleContainer) ensureOpen(visibleContainer);
  }

  /**
   * AB buy-area reorder: move the free-gifts list below the yellow divider
   * when Liquid left it inside the yellow ATC box.
   */
  function relocateBuyAreaGifts() {
    const isAb = document.body.classList.contains('template-template-starter-kit-ab-buy-area-reorder')
      || !!document.querySelector('.product-showcase--buy-area-reorder');
    if (!isAb) return;

    const info = document.querySelector('.product-showcase__info');
    if (!info) return;

    const inBoxList = document.querySelector('.product-showcase__actions .product-actions__includes');
    let slot = document.querySelector('#ps-slot-free-gifts');

    if (!slot) {
      slot = document.createElement('div');
      slot.id = 'ps-slot-free-gifts';
      slot.className = 'product-showcase__info-block product-showcase__free-gifts';

      const description = info.querySelector('#ps-slot-description, .block-description');
      const honey = info.querySelector('.product-variants--honey');
      if (description && description.parentElement) {
        description.parentElement.insertBefore(slot, description.nextSibling);
      } else if (honey && honey.parentElement) {
        honey.parentElement.insertBefore(slot, honey);
      } else {
        info.insertBefore(slot, info.firstChild);
      }
    }

    if (inBoxList && !slot.contains(inBoxList)) {
      slot.innerHTML = '';
      slot.appendChild(inBoxList);
    }

    normalizeBuyAreaGifts(slot);
  }

  /**
   * Drop the paid product row and keep the guidebook last after AJAX swaps.
   * @param {Element} [slot]
   */
  function normalizeBuyAreaGifts(slot) {
    const root = slot || document.querySelector('#ps-slot-free-gifts');
    if (!root) return;

    const list = root.querySelector('.product-actions__includes');
    if (!list) return;

    const items = Array.from(
      list.querySelectorAll(':scope > .product-actions__includes-item')
    );
    /** @type {Element|null} */
    let guidebook = null;

    items.forEach((item) => {
      const title = (
        item.querySelector('.product-actions__includes-text-title')?.textContent || ''
      ).toLowerCase();
      const price = (
        item.querySelector('.product-actions__includes-current-price')?.textContent || ''
      ).trim().toUpperCase();
      const isGuidebook = title.indexOf('guidebook') !== -1;
      const isProductRow = price !== 'FREE'
        || (title.indexOf('mgo') !== -1
          && title.indexOf('raw') !== -1
          && title.indexOf('honey') !== -1);

      if (isProductRow && !isGuidebook) {
        item.remove();
        return;
      }

      if (isGuidebook) {
        guidebook = item;
      }
    });

    if (guidebook) {
      list.appendChild(guidebook);
    }
  }

  // Initialize on load
  document.addEventListener('DOMContentLoaded', () => {
    initProductVideo();
    enforceTwoOptionsSimplified();
    applyCurrentSelection();
    ensureStickyVisible();
    ensureSingleOpen();
    initMobileSwiper();
    // Set initial guarantees visibility based on selected option
    updateGuaranteesFromSelection();
    relocateBuyAreaGifts();
  });
  // Re-apply after product or variant changes
  document.addEventListener('pdp:product-changed', (event) => {
    const detail = /** @type {{ skipApplySelection?: boolean }|undefined} */((/** @type {CustomEvent} */(event)).detail);
    const skipApplySelection = !!(detail && detail.skipApplySelection);

    // mgo-variants.js already restored the selected option and panel state.
    // Running applyCurrentSelection() again causes visible close/open flicker.
    if (!skipApplySelection) {
      enforceTwoOptionsSimplified();
      applyCurrentSelection();
    }
    // ensureSingleOpen() debe ejecutarse SIEMPRE, incluso con skipApplySelection:
    // tras el swap AJAX, mgo-variants.js restaura is-active/is-selected pero NO abre
    // el acordeón, así que en layout single (p.ej. solo One-Time) el panel quedaba
    // cerrado y parecía que ninguna opción estaba activa. ensureSingleOpen() es
    // idempotente y hace early-return en multi-layout, por lo que es seguro aquí.
    ensureSingleOpen();
    initMobileSwiper();
    // Update guarantees visibility after product change
    updateGuaranteesFromSelection();
    relocateBuyAreaGifts();
  });
  
  /**
   * Update guarantees visibility based on currently selected option
   */
  function updateGuaranteesFromSelection() {
    const container = /** @type {HTMLElement|null} */(document.querySelector('#subscribe-options-static'));
    if (!container) return;
    const selected = /** @type {HTMLElement|null} */(container.querySelector('.product-showcase__subscribe--option.is-selected, .product-showcase__subscribe--option.is-active'));
    if (!selected) return;
    const type = selected.getAttribute('data-type') || 'onetime';
    toggleSubscriptionGuarantees(type);
  }
  // Re-bind video controls after gallery DOM is swapped
  document.addEventListener('pdp:gallery-updated', () => {
    initProductVideo();
    initMobileSwiper();
  });

  // Make sticky add-to-cart visible (defensive to match different markup variants)
  function ensureStickyVisible() {
    /** @type {(HTMLElement|null)[]} */
    const candidates = [
      /** @type {HTMLElement|null} */(document.querySelector('#sticky-add-to-cart')),
      /** @type {HTMLElement|null} */(document.querySelector('.sticky-add-to-cart')),
      /** @type {HTMLElement|null} */(document.querySelector('[data-sticky-add-to-cart]')),
    ];
    for (const el of candidates) {
      if (!el) continue;
      el.classList.remove('is-hidden', 'hidden');
      el.classList.add('is-visible');
      el.setAttribute('aria-hidden', 'false');
      el.style.display = '';
      break;
    }
  }

  // Listen to Sticky bar selection and reflect in main options
  document.addEventListener('pdp:option-selected', function(ev){
    const d = /** @type {{source?:string,type?:string,planId?:string,variantId?:string}} */((/** @type {CustomEvent} */(ev)).detail || {});
    if (!d || d.source === 'main') return;
    const container = /** @type {HTMLElement|null} */(document.querySelector('#subscribe-options-static'));
    if (!container) return;
    let target = /** @type {HTMLElement|null} */(null);
    if (d.variantId) {
      target = container.querySelector(`.product-showcase__subscribe--option[data-variant-id="${d.variantId}"]`);
    }
    if (d.planId) {
      target = container.querySelector(`.product-showcase__subscribe--option[data-selling-plan-id="${d.planId}"]`);
    }
    if (!target && d.type) {
      target = container.querySelector(`.product-showcase__subscribe--option[data-type="${d.type}"]`);
    }
    if (!target) {
      // Fallback: directly adjust ATC href so sticky works even if option is outside this container
      const atc = /** @type {HTMLAnchorElement|null} */(document.querySelector('.product-showcase__add-to-cart'));
      if (!atc) return;
      const href = atc.getAttribute('href') || '/cart/add';
      const url = new URL(href, window.location.origin);
      url.searchParams.delete('selling_plan');
      const sizeSelection = getSelectedSizeCartSelection();
      const isV2Context = isActionsV2Context();
      const canOptionOverrideVariant = d.type === 'subscription-special';
      if (canOptionOverrideVariant && d.variantId) {
        url.searchParams.set('id', d.variantId);
        if (d.planId) url.searchParams.set('selling_plan', d.planId);
      } else {
        // No variantId provided (e.g., switching away from special). Reset to main product selected variant
        let mainVariantId = sizeSelection.variantId || getSelectedSizeCartVariantId();
        if (!mainVariantId) {
          const params = new URLSearchParams(location.search);
          mainVariantId = params.get('variant') || '';
        }
        if (mainVariantId) url.searchParams.set('id', mainVariantId);
        if (isV2Context && sizeSelection.isStarterKitOverride) {
          if (sizeSelection.sellingPlanId) url.searchParams.set('selling_plan', sizeSelection.sellingPlanId);
        } else if (d.planId) {
          url.searchParams.set('selling_plan', d.planId);
        }
      }
      const qs = url.searchParams.toString();
      atc.setAttribute('href', qs ? (url.pathname + '?' + qs) : url.pathname);
      return;
    }
    const evt = new Event('click', { bubbles: true, cancelable: true });
    target.dispatchEvent(evt);
  });
  // Detect if page is using the single subscribe layout (only one container under #subscribe-options-static)
  function isSingleLayout() {
    const root = /** @type {HTMLElement|null} */(document.querySelector('#subscribe-options-static'));
    if (!root) return false;
    const containers = root.querySelectorAll('.product-showcase__subscribe--container');
    return containers.length === 1;
  }

  // Ensure a subscribe container's actions are opened
  function ensureOpen(container) {
    const actionsContainer = /** @type {HTMLElement|null} */(container.querySelector('.product-showcase__actions-container'));
    if (!actionsContainer) return;
    actionsContainer.classList.add('dropdown-open');
    const header = /** @type {HTMLElement|null} */(container.querySelector('.product-showcase__actions--header'));
    if (header) header.setAttribute('aria-expanded', 'true');
  }

  /**
   * Toggle dropdown functionality from an option element
   * @param {HTMLElement} selectedOption
   */
  function toggleDropdown(selectedOption) {
    // Find the container that holds this option
    const container = /** @type {HTMLElement|null} */(selectedOption.closest('.product-showcase__subscribe--container'));
    if (!container) return;
    // In single layout, keep it open and do nothing else
    if (isSingleLayout()) {
      ensureOpen(container);
      return;
    }
    // Option click must keep the selected panel open (never collapse the active panel).
    toggleDropdownByContainer(container, true);
  }

  /**
   * Toggle dropdown by container (used by header click and option click)
   * @param {HTMLElement} container
   */
  function toggleDropdownByContainer(container, forceOpen = false) {
    // Find the actions container within this container
    const actionsContainer = /** @type {HTMLElement|null} */(container.querySelector('.product-showcase__actions-container'));
    if (!actionsContainer) return;

    // In single layout, keep it open and exit
    if (isSingleLayout()) {
      ensureOpen(container);
      return;
    }

    const isOpen = actionsContainer.classList.contains('dropdown-open');
    const currentlyOpen = /** @type {HTMLElement|null} */(document.querySelector('.product-showcase__actions-container.dropdown-open'));

    // If clicking an already open one, close it (true toggle)
    if (isOpen && !forceOpen) {
      actionsContainer.classList.remove('dropdown-open');
      const header = /** @type {HTMLElement|null} */(container.querySelector('.product-showcase__actions--header'));
      if (header) header.setAttribute('aria-expanded', 'false');
      return;
    }

    // Close ALL other open containers to enforce single-open behavior
    /** @type {NodeListOf<HTMLElement>} */
    const openContainers = document.querySelectorAll('.product-showcase__actions-container.dropdown-open');
    openContainers.forEach((oc) => {
      if (oc === actionsContainer) return;
      oc.classList.remove('dropdown-open');
      const h = /** @type {HTMLElement|null} */(oc.closest('.product-showcase__subscribe--container')?.querySelector('.product-showcase__actions--header'));
      if (h) h.setAttribute('aria-expanded', 'false');
    });
    actionsContainer.classList.add('dropdown-open');
    const header = /** @type {HTMLElement|null} */(container.querySelector('.product-showcase__actions--header'));
    if (header) header.setAttribute('aria-expanded', 'true');
  }

  // Keyboard support on headers (Enter/Space)
  document.addEventListener('keydown', (e) => {
    if (!(e.target instanceof Element)) return;
    const header = /** @type {HTMLElement|null} */(e.target.closest('.product-showcase__subscribe--container .product-showcase__actions--header'));
    if (!header) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      const container = /** @type {HTMLElement|null} */(header.closest('.product-showcase__subscribe--container'));
      if (container) toggleDropdownByContainer(container);
    }
  });

  // Initialize first dropdown as open by default
  function initializeDropdowns() {
    const root = /** @type {HTMLElement|null} */(document.querySelector('#subscribe-options-static'));
    if (!root) return;
    const isOtpAccordion = root.classList.contains('ps-otp-accordion');

    if (isOtpAccordion) {
      let target = /** @type {HTMLElement|null} */(root.querySelector('.product-showcase__subscribe--option.is-selected'));
      if (!target) {
        target = /** @type {HTMLElement|null} */(root.querySelector('.product-showcase__subscribe--option'));
      }
      if (!target) return;

      // Keep exactly one selected option in accordion scopes.
      root.querySelectorAll('.product-showcase__subscribe--option').forEach((opt) => opt.classList.remove('is-selected'));
      target.classList.add('is-selected');

      // Keep one active source for mgo-variants selection logic.
      document.querySelectorAll('.product-showcase__subscribe--option').forEach((opt) => opt.classList.remove('is-active'));
      target.classList.add('is-active');

      // Respect schema-driven default_open from Liquid by opening the selected container.
      root.querySelectorAll('.product-showcase__actions-container').forEach((actions) => {
        actions.classList.remove('dropdown-open');
        const header = /** @type {HTMLElement|null} */(actions.closest('.product-showcase__subscribe--container')?.querySelector('.product-showcase__actions--header'));
        if (header) header.setAttribute('aria-expanded', 'false');
      });

      const targetContainer = /** @type {HTMLElement|null} */(target.closest('.product-showcase__subscribe--container'));
      const targetActions = /** @type {HTMLElement|null} */(targetContainer?.querySelector('.product-showcase__actions-container') || null);
      if (targetActions) {
        targetActions.classList.add('dropdown-open');
        const targetHeader = /** @type {HTMLElement|null} */(targetContainer?.querySelector('.product-showcase__actions--header') || null);
        if (targetHeader) targetHeader.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    // First, close ALL dropdowns to ensure clean state
    const allContainers = document.querySelectorAll('.product-showcase__actions-container');
    allContainers.forEach((container) => {
      container.classList.remove('dropdown-open');
      const header = /** @type {HTMLElement|null} */(container.closest('.product-showcase__subscribe--container')?.querySelector('.product-showcase__actions--header'));
      if (header) header.setAttribute('aria-expanded', 'false');
    });

    // Remove all is-selected and is-active from options
    document.querySelectorAll('.product-showcase__subscribe--option').forEach((opt) => {
      opt.classList.remove('is-selected', 'is-active');
    });

    // Now open ONLY the first container
    const firstContainer = /** @type {HTMLElement|null} */(document.querySelector('.product-showcase__subscribe--container:first-child'));
    if (firstContainer) {
      const firstActionsContainer = /** @type {HTMLElement|null} */(firstContainer.querySelector('.product-showcase__actions-container'));
      if (firstActionsContainer) {
        firstActionsContainer.classList.add('dropdown-open');
        const header = /** @type {HTMLElement|null} */(firstContainer.querySelector('.product-showcase__actions--header'));
        if (header) header.setAttribute('aria-expanded', 'true');
      }
      
      // Also mark the first option as selected AND active
      const firstOption = /** @type {HTMLElement|null} */(firstContainer.querySelector('.product-showcase__subscribe--option'));
      if (firstOption) {
        firstOption.classList.add('is-selected');
        // Add is-active to prevent mgo-variants.js from auto-selecting another option
        firstOption.classList.add('is-active');
      }
    }
  }

  // Initialize dropdowns on load
  document.addEventListener('DOMContentLoaded', initializeDropdowns);

  // Initialize unified gallery Swiper (desktop + mobile via same DOM structure)
  function initMobileSwiper() {
    if (typeof window === 'undefined' || typeof window.Swiper === 'undefined') return;
    const SwiperCtor = /** @type {any} */ (window.Swiper);
    if (!SwiperCtor) return;

    const psw = /** @type {any} */(window).__psw;
    try {
      if (psw?.mainSwiper && typeof psw.mainSwiper.destroy === 'function') {
        psw.mainSwiper.destroy(true, true);
      }
      if (psw?.thumbsSwiper && typeof psw.thumbsSwiper.destroy === 'function') {
        psw.thumbsSwiper.destroy(true, true);
      }
    } catch (_) { /* noop */ }

    /** @type {HTMLElement|null} */
    const mainEl = document.querySelector('.product-showcase__gallery--main');
    if (!mainEl) return;

    /** @type {HTMLElement|null} */
    const thumbsEl = document.querySelector('.product-showcase__gallery--thumbs');
    /** @type {HTMLElement|null} */
    const dotsEl = document.querySelector('.product-showcase__gallery--pagination');

    /** @type {any} */
    const galleryEl = document.querySelector('product-showcase-gallery');
    const showDesktopThumbs = galleryEl ? galleryEl.getAttribute('data-show-desktop-thumbs') !== 'false' : true;
    const mobileNav = galleryEl ? galleryEl.getAttribute('data-mobile-nav') : 'thumbnails';

    let thumbsSwiper = null;
    if (thumbsEl) {
      thumbsSwiper = new SwiperCtor(thumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
        freeMode: true,
        breakpoints: {
          991: { spaceBetween: 12 },
        },
      });
    }

    const isMobile = window.innerWidth <= 990;

    /** @type {any} */
    const swiperConfig = {
      spaceBetween: 0,
      slidesPerView: 1,
      centeredSlides: false,
      navigation: {
        prevEl: '.product-showcase__gallery--prev',
        nextEl: '.product-showcase__gallery--next',
      },
      breakpoints: {
        0: {
          slidesPerView: mobileNav === 'dots' ? 1 : 1,
          spaceBetween: 0,
        },
      },
    };

    if (dotsEl) {
      swiperConfig.pagination = {
        el: dotsEl,
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      };
    }

    // Attach thumbs on desktop (always) and on mobile when navigation type is thumbnails
    const shouldUseThumbs = thumbsSwiper && (
      (!isMobile && showDesktopThumbs) ||
      (isMobile && mobileNav !== 'dots')
    );
    if (shouldUseThumbs) {
      swiperConfig.thumbs = { swiper: thumbsSwiper };
    }

    const mainSwiper = new SwiperCtor(mainEl, swiperConfig);

    /** @type {any} */(window).__psw = { mainSwiper, thumbsSwiper };
  }

  // Flag to prevent duplicate add to cart calls
  let isAddingToCart = false;

  async function handleAddToCartClick(e, button) {
    console.log('Add to cart button clicked!', button);
    e.preventDefault();
    e.stopPropagation(); // Stop event from bubbling up
    e.stopImmediatePropagation(); // Stop other handlers on same element
    
    if (!button) return;
    
    // Prevent duplicate calls
    if (isAddingToCart) {
      console.log('Already adding to cart, ignoring duplicate call');
      return;
    }
    
    const href = button.getAttribute('href');
    if (!href) return;
    
    const url = new URL(href, window.location.origin);
    let variantId = url.searchParams.get('id');
    const quantity = url.searchParams.get('quantity') || '1';
    const sellingPlan = url.searchParams.get('selling_plan');

    const activeOption = /** @type {HTMLElement|null} */(
      document.querySelector('.product-showcase__subscribe--option.is-active')
      || document.querySelector('.product-showcase__subscribe--option.is-selected')
    );
    const activeType = activeOption ? (activeOption.getAttribute('data-type') || '') : '';
    const activeVariantId = activeOption ? (activeOption.getAttribute('data-variant-id') || '') : '';
    const sizeSelection = getSelectedSizeCartSelection();
    const isV2Context = isActionsV2Context();
    const selectedSizeCartVariantId = sizeSelection.variantId;

    const isOnetimePurchase = activeType === 'onetime' || button.hasAttribute('data-onetime-only');

    if (activeType === 'subscription-special' && activeVariantId) {
      variantId = activeVariantId;
    } else if (isOnetimePurchase && isV2Context) {
      // One-time must always use the real PDP variant (never data-cart-variant-id SK override).
      variantId = getCurrentPdpVariantId();
    } else if (!isV2Context && activeVariantId) {
      // Legacy blocks: keep option variant override behavior.
      variantId = activeVariantId;
    } else if (selectedSizeCartVariantId) {
      variantId = selectedSizeCartVariantId;
    }

    let effectiveSellingPlan = '';
    if (!isOnetimePurchase) {
      const activePlanId = activeOption ? (activeOption.getAttribute('data-selling-plan-id') || '') : '';
      if (activeType === 'subscription-special') {
        effectiveSellingPlan = activePlanId || sellingPlan || '';
      } else if (isV2Context && sizeSelection.isStarterKitOverride) {
        effectiveSellingPlan = sizeSelection.sellingPlanId || activePlanId || sellingPlan || '';
      } else {
        effectiveSellingPlan = activePlanId || sellingPlan || '';
      }
    }
    
    if (!variantId) return;
    
    // Set flag and disable button
    isAddingToCart = true;
    button.disabled = true;
    button.classList.add('loading');
    const originalText = button.innerHTML;
    button.innerHTML = '<span class="product-showcase__atc-spinner" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8" stroke="#2E2E24" stroke-opacity="0.22" stroke-width="2"/><path d="M18 10C18 5.58172 14.4183 2 10 2" stroke="#2E2E24" stroke-width="2" stroke-linecap="round"/></svg></span>';
    
    try {
      const payload = {
        id: variantId,
        quantity: parseInt(quantity)
      };
      
      if (effectiveSellingPlan) {
        payload.selling_plan = effectiveSellingPlan;
      }
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      
      if (!response.ok) {
        const message = await readCartErrorMessage(
          response,
          'Error adding to cart. Please try again.'
        );
        showCartErrorModal(message);
        resetAddToCartButton();
        return;
      }
      
      const result = await response.json();
      
      document.dispatchEvent(new CustomEvent('cart:update-counter'));
      
      document.dispatchEvent(new CustomEvent('cart:refresh-open'));
      
      setTimeout(function() {
        button.classList.remove('loading');
        button.innerHTML = '✓ Added!';
        
        setTimeout(function() {
          button.innerHTML = originalText;
          button.disabled = false;
          isAddingToCart = false; // Reset flag after completion
        }, 1000);
      }, 1000);
      
    } catch (error) {
      console.error('[Product Showcase] Add to cart error:', error);
      showCartErrorModal('Error adding to cart. Please try again.');
      resetAddToCartButton();
    }

    /**
     * Restore the add to cart button after a failed request.
     */
    function resetAddToCartButton() {
      button.classList.remove('loading');
      button.innerHTML = originalText;
      button.disabled = false;
      isAddingToCart = false;
    }
  }

  function initBundleVariantText() {
    const bundleContainers = document.querySelectorAll('.product-variants--bundle');
    bundleContainers.forEach(container => {
      const selectedSpan = container.querySelector('.product-variants__selected');
      const activeButton = container.querySelector('.variant-product--active .variant-product__title');
      
      if (selectedSpan && activeButton) {
        selectedSpan.textContent = activeButton.textContent || '';
      }
    });
  }

  initBundleVariantText();

  /**
   * Custom event listener for add to cart from page builder
   * Escucha el evento 'pagebuilder:addtocart' con los datos necesarios
   */
  document.addEventListener('pagebuilder:addtocart', async function(event) {
    console.log('[Page Builder] Add to cart event received:', event.detail);
    
    const { variantId, quantity, sellingPlan } = event.detail;
    
    if (!variantId) {
      console.error('[Page Builder] Variant ID is required');
      return;
    }
    
    // Prevent duplicate calls
    if (isAddingToCart) {
      console.log('[Page Builder] Already adding to cart, ignoring duplicate call');
      return;
    }
    
    // Set flag
    isAddingToCart = true;
    
    try {
      const payload = {
        id: variantId,
        quantity: parseInt(quantity) || 1
      };
      
      if (sellingPlan) {
        payload.selling_plan = sellingPlan;
      }
      
      console.log('[Page Builder] Adding to cart with payload:', payload);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      
      if (!response.ok) {
        const message = await readCartErrorMessage(
          response,
          'Error adding to cart. Please try again.'
        );
        showCartErrorModal(message);
        isAddingToCart = false;
        return;
      }
      
      const result = await response.json();
      console.log('[Page Builder] Product added to cart:', result);
      
      // Update cart counter
      document.dispatchEvent(new CustomEvent('cart:update-counter'));
      
      // Open cart drawer
      document.dispatchEvent(new CustomEvent('cart:refresh-open'));
      
      // Reset flag after completion
      setTimeout(() => {
        isAddingToCart = false;
      }, 1000);
      
    } catch (error) {
      console.error('[Page Builder] Add to cart error:', error);
      showCartErrorModal('Error adding to cart. Please try again.');
      isAddingToCart = false;
    }
  });

})();

/**
 * Función global para agregar al carrito desde page builder
 * Uso: addToCartFromPageBuilder(variantId, quantity, sellingPlan)
 * 
 * @param {string|number} variantId - ID de la variante a agregar
 * @param {number} quantity - Cantidad (opcional, default: 1)
 * @param {string|number} sellingPlan - ID del selling plan (opcional, para suscripciones)
 */
window.addToCartFromPageBuilder = function(variantId, quantity, sellingPlan) {
  console.log('[Page Builder] addToCartFromPageBuilder called with:', { variantId, quantity, sellingPlan });
  
  if (!variantId) {
    console.error('[Page Builder] Variant ID is required');
    return;
  }
  
  // Dispatch custom event
  document.dispatchEvent(new CustomEvent('pagebuilder:addtocart', {
    detail: {
      variantId: variantId.toString(),
      quantity: quantity || 1,
      sellingPlan: sellingPlan ? sellingPlan.toString() : null
    }
  }));
};